module.exports = __webpack_public_path__ + "static/img/6.0fc752e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/6.png
// module id = pJUM
// module chunks = 0